<template>
    <div class="legends">
        <div class="circle"
            :key="index"
              v-for="(isActive, index) in itemList"
              :class="{'active':isActive}"
              @click="select(index)"
        ></div>
    </div>
</template>
<style scoped>
    .legends {
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 60px;
        width: 100%;
    }
    .circle {
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background-color: #BDBDBD;
        display: inline-block;
    }
    .circle.active {
        background-color: #27AE60;
    }
</style>
<script>
export default {
    props: { total: Number, value: Number },
    computed: {
        itemList () {
            const result = []
            for (let i = 0; i < this.total || 0; i++) {
                result.push(i === this.value)
            }
            return result
        }
    },
    methods: {
        select (index) {
            this.$emit('input', index)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/carousel/src/legends.vue